import React from 'react';
import styled from '@emotion/styled';
import { HEADER_INDEX } from '../../../../styles/constants/priority';
import { HEADER_HEIGHT } from '../../../../styles/constants/size';
import { HEAVY_GRAY, WHITE } from '../../../../styles/constants/color';
import NavigationBody from './NavigationBody';

const Nav = styled.nav<{ active: boolean }>`
  left: 0;
  top: ${HEADER_HEIGHT};
  position: fixed;
  width: 100%;
  height: ${props => (props.active ? '420px' : 0)};
  transition: height 0.2s ease-in-out;
  z-index: ${HEADER_INDEX};
  background-color: ${WHITE};
  box-shadow: 4px 2px 3px ${HEAVY_GRAY};
  overflow: hidden;

  @media (max-width: 768px) {
    height: ${props => (props.active ? '280px' : 0)};
  }
`;

interface Props {
  active: boolean;
  closeEvent: () => void;
}

/**
 *  헤더 네비게이션 컴포넌트
 * @param {boolean} active 네비게이션 활성화 여부
 * @param {function} closeEvent 네비게이션 비활성화 클릭 함수
 *  */
function Navigation({ active, closeEvent }: Props): JSX.Element {
  return (
    <Nav active={active}>
      <NavigationBody closeEvent={closeEvent} />
    </Nav>
  );
}

export default Navigation;
